import React from 'react';

const Ourmission1 = () => {
    return (
        <section className="skill-section bg-grey padding">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-6">
                        <div className="video-wrap">
                            <img src="assets/img/post-11.jpg" alt="img" />
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="section-heading mb-30">

                            <h2 className="text-anim" data-effect="fade-in-right" data-split="char" data-delay="0.3" data-duration={1}> Our Mission  </h2>
                            <p className="text-anim" data-effect="fade-in-bottom" data-ease="power4.out"> Our mission is to deliver comprehensive IT solutions that empower individuals and organizations to excel in their respective fields. By providing industry-relevant training, staffing exceptional talent, and executing transformative IT projects, we aim to shape a brighter, technology-driven future. </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Ourmission1;